import moment from 'moment'
const helper = {
  filters: {
    date: function (value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  localeText: {
    // for filter panel
    page: 'Página',
    more: 'Más',
    to: 'a',
    of: 'de',
    next: 'siguiente',
    last: 'último',
    first: 'primero',
    previous: 'anterior',
    loadingOoo: 'Cargando...',

    // for set filter
    selectAll: 'Seleccionar todos',
    searchOoo: 'Buscar...',
    blanks: 'en blanco',

    // for number filter and text filter
    filterOoo: 'Filtro...',
    applyFilter: 'Aplicar filtro...',

    // for number filter
    equals: 'Igual',
    notEqual: 'Diferente',
    lessThan: 'Menor a',
    greaterThan: 'Mayor a',

    // for text filter
    contains: 'Contiene',
    notContains: 'No Contiene',
    startsWith: 'Inicia con',
    endsWith: 'Termina con',

    // the header of the default group column
    group: 'Grupo',

    // tool panel
    columns: 'Columnas',
    rowGroupColumns: 'Columnas pivote',
    rowGroupColumnsEmptyMessage: 'Arrastre columnas para agrupar',
    valueColumns: 'laValue Cols',
    pivotMode: 'Modo Pivote',
    groups: 'Grupos',
    values: 'Valores',
    pivots: 'Pivotes',
    valueColumnsEmptyMessage: 'Arrastre columnas para agrupar',
    pivotColumnsEmptyMessage: 'Arrastre aquí para hacer pivote',
    toolPanelButton: 'Herramientas',

    // other
    noRowsToShow: 'Sin Registros',

    // enterprise menu
    pinColumn: 'Fijar Columna',
    valueAggregation: 'Valor agrupado',
    autosizeThiscolumn: 'Tamaño automático',
    autosizeAllColumns: 'Tamaño automático para todas',
    groupBy: 'Agrupar por',
    ungroupBy: 'Desagrupar por',
    resetColumns: 'Resetear columnas',
    expandAll: 'Expandir',
    collapseAll: 'Cerrar',
    toolPanel: 'Herramientas',
    export: 'Exportar',
    csvExport: 'Exportar CSV',
    excelExport: 'Exportar Excel',

    // enterprise menu pinning
    pinLeft: 'laPin <<',
    pinRight: 'laPin >>',
    noPin: 'laDontPin <>',

    // enterprise menu aggregation and status panel
    sum: 'Suma',
    min: 'Min',
    max: 'Max',
    none: 'Ninguno',
    count: 'Contar',
    average: 'Promedio',

    // standard menu
    copy: 'Copiar',
    copyWithHeaders: 'Copiar con cabeceras',
    ctrlC: 'ctrl + C',
    paste: 'Pegar',
    ctrlV: 'ctrl + V'
    }
}

helper.install = function (Vue, options) {
  Vue.prototype.$helper = helper
}

export default helper



// WEBPACK FOOTER //
// ./src/plugins/helper.js